// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "-es2015." + {"src_app_dashboard_dashboard_module_ts":"0cca9dcb295214b38eea","src_app_document-filter_document-filter_module_ts":"364f869109c4d70a1bde"}[chunkId] + ".js";
};